import React from 'react';

const Header = () => {
    return(
        <div className="header">
            <h1>Generate a Random Phrase & Use It As Your Password</h1>
            <ol>
            <li>1. Press the spin button</li>
            <li>2. Press the stop button</li>
            <li>3. Use the randomly generated phrase for your password</li>
            </ol>
        </div>
    )
};

export default Header
